import { Button, Menu } from "antd";
import styled from "styled-components";


export const PhysicianPageWrapper = styled.div`
  .ant-card{
    border-radius: 10px;
    // box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
    box-shadow: none;
    border: 1px solid var(--border-color);
  }
  .ant-card-body{
    padding: 16px;
  }
  .ant-card-head{
    border-bottom: 1px solid var(--border-color) !important;
  }
  .ant-segmented {
    background-color: var(--border-color) !important;
  }
  .ant-segmented-thumb {
  background-color: var(--primary-bg);
  }
  .ant-segmented-item{
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--secondary-text-color) !important;

    &:hover {
      color: none !important;
    }
  }  
  .ant-segmented-item-selected{
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ant-segmented-item-label{
    font-size: 16px;
    font-weight: 600;
  }
  .ant-segmented-item-selected {
    background-color: var(--primary-bg) !important;
    color: var(--primary-text-color) !important;
  }
  .ant-progress-bg, .ant-progress-success-bg{
    background-color: #8a3ef4 !important;
  }
  .ant-progress-inner{
    background-color: var(--secondary-bg) !important;
  }
  .ant-table-container {
    overflow: auto;
    height: 440px;
  }
`;

export const CustomButton = styled(Button)`
  background-color: #8a3ef4 !important;
  border: none;
  border-radius: 5px;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: none;
  color: #fff !important;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover{
    background-color: rgba(156, 90, 249, 0.99) !important;
    color: #fff;
  }
  &:active{
    background-color: #8a3ef4 !important;
    color: #fff !important;
  }
  &:focus{
    background-color: #8a3ef4 !important;
    color: #fff !important;
  }
`;

export const CustomTitle = styled.div`
  font-size: 26px;
  color: var(--primary-text-color);
  margin: 0;
  font-weight: 700;
`;

export const CustomSubTitle = styled.div`
  font-size: 17px;
  color: var(--secondary-text-color);
  margin: 0;

`;

export const CustomSecondaryButton = styled(Button)`
  border-radius: 5px;
  font-weight: 600;
  box-shadow: none;
  font-size: 15px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-text-color);


  &:hover{
    background-color: var(--secondary-bg) !important;
    border: 1px solid var(--secondary-bg);
    color: var(--primary-text-color);
  }
  &:active{
    border-color: #8a3ef4 !important;
    color: #8a3ef4 !important;
  }
  &:focus{
    border-color: #8a3ef4 !important;
    color: #8a3ef4 !important;
  }
`;

export const CustomFilterSelection = styled.div`
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 6px;
    // height: 40px;
    align-items: center;
    background-color: var(--primary-bg) !important;
    border: 1px solid var(--border-color) !important;
  }
  .ant-select {
    background-color: var(--primary-bg) !important;
    color: var(--primary-text-color);
    font-size: 14px;
  }
  .ant-select-arrow {
    color: var(--primary-text-color);
  }
  .ant-select-item {
    background-color: var(--primary-bg) !important;
    color: var(--primary-text-color);
  }
  .ant-select-clear {
    background-color: var(--primary-bg) !important;
    color: var(--primary-text-color);
  }
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector{
    border-color: #8a3ef4 !important;
  }
`;

export const CustomFilterSelectionForMyVideoPage = styled.div`
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 6px;
    height: 42px !important;
    align-items: center;
    background-color: var(--primary-bg) !important;
    border: 1px solid var(--border-color) !important;
  }
  .ant-select {
    background-color: var(--primary-bg) !important;
    color: var(--primary-text-color);
    font-size: 14px;
  }
  .ant-select-arrow {
    color: var(--primary-text-color);
  }
  .ant-select-item {
    background-color: var(--primary-bg) !important;
    color: var(--primary-text-color);
  }
  .ant-select-clear {
    background-color: var(--primary-bg) !important;
    color: var(--primary-text-color);
  }
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector{
    border-color: #8a3ef4 !important;
  }
  .ant-select-selection-placeholder{
    color: var(--secondary-text-color);
  }
`;

export const StyledMenu = styled(Menu)`
  min-width: 220px;
  padding: 4px;
  border-radius: 8px;
  background-color: var(--primary-bg);
  border: 1px solid var(--border-color);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  .ant-dropdown-menu-item {
    padding: 8px 12px;
    margin: 2px 0;
    border-radius: 6px;
    transition: all 0.3s ease;
    color: var(--primary-text-color);

    &:hover {
      background-color: var(--secondary-bg);
    }

    .menu-item-content {
      display: flex;
      align-items: center;
      gap: 8px;

      .menu-item-icon {
        color: var(--secondary-text-color);
        font-size: 16px;
      }

      .menu-item-text {
        color: var(--primary-text-color);
        font-size: 14px;
        font-weight: 500;
      }
    }

    .ant-switch {
      margin-left: auto;
    }
  }

  .ant-dropdown-menu-item-selected {
    background-color: var(--secondary-bg);
    color: var(--primary-text-color);
  }

  .ant-dropdown-menu-item-active {
    background-color: var(--secondary-bg);
  }
`;